<template>
    <div class="white">
        <v-row wrap>
            <v-col xs12 sm7>
                <div class="ma-3 pa-3 white text-align-center">
                    <h5>Welcome to Taco</h5>
                    <img width="120 " src="/static/images/taco.jpg" />
                    <br/><br/>
                    <p>This page is going to look awesome when I think of something cool and witty to say here.</p>
                </div>
            </v-col>
            <v-col xs12 sm5>
                <div v-if="signInEnabled" class="ma-3 pa-3 grey lighten-2 text-align-center">

                    <v-btn :disabled="!signInEnabled" @click.native="signIn" class="primary">
                        <!-- <v-icon dark left>verified_user</v-icon> -->
                        Login with Google
                    </v-btn>
                </div>
                <div v-else class="ma-3 pa-3 grey lighten-2 text-align-center">
                    <v-progress-circular indeterminate class="primary--text"></v-progress-circular> <br/>
                </div>

            </v-col>
        </v-row>
        <div style="height:400px"></div>

    </div>
</template>

<script>
    import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
    //import NumberHelpers from '../helpers/NumberHelpers.js';
    export default {
        name: 'Welcome',
        data() {
            return {
                assignedTo: ''
            }
        },
        computed: {
            signInEnabled () {
                let enabled = localStorage.getItem("loginStatus") == "Signed Out"
                return enabled
            }

        },
        methods: {
            signIn: function(){
                        console.log('signing in')

                        localStorage.setItem("loginStatus", "Signing In")

                        let provider = new firebase.auth.GoogleAuthProvider()
                        provider.addScope('email')
                        provider.addScope('profile')

                        //firebase.auth().signInWithRedirect(provider)
                        firebase.auth().signInWithPopup(provider)
                    }

        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Welcome.vue?85cb0778